function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const YoutubeIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 17.6l7.6-3.9-7.6-4v7.9zM14 4.2c5.9 0 9.8.3 9.8.3.5.1 1.8.1 2.8 1.2 0 0 .9.8 1.1 2.8.3 2.3.3 4.5.3 4.5v2.1s0 2.3-.3 4.5c-.2 1.9-1.1 2.8-1.1 2.8-1.1 1.1-2.3 1.1-2.8 1.2 0 0-3.9.3-9.8.3-7.3-.1-9.5-.3-9.5-.3-.6-.1-2-.1-3.1-1.2 0 0-.9-.9-1.1-2.8-.3-2.3-.3-4.5-.3-4.5V13s0-2.3.3-4.5c.2-1.9 1.1-2.8 1.1-2.8 1.1-1.1 2.3-1.1 2.8-1.2 0-.1 3.9-.3 9.8-.3z"
  }));
};
export default YoutubeIcon;